
import React, {  useEffect } from 'react'
import { useFieldArray } from 'react-hook-form';
import AInput from '../../components/fields/AInput';
import ASelect from '../../components/fields/ASelect';

export default function CustomItemsFields({ v }) {
    const { fields, append } = useFieldArray({
        control: v.control,
        name: v.items
    });

    console.log("ItemsComp", v?.data);

    useEffect(() => {
        if (fields?.length === 0) appendFieldArrayData()
    }, [])

    const appendFieldArrayData = () => {
        append({ ...v?.data?.fields })
    }

    const getOBJKeys = (obj) => obj?Object.keys(obj):null


    return (
        <fieldset className= {`border border-solid border-gray-300 px-2 py-1 rounded-md ${v.data?.className}`}>
            <legend className={`text-base text-black font-semibold amiriB ${v.className}`}>اجناس</legend>
            <div className='overflow-auto grid grid-cols-1  '>
                <table className=' w-full border-separate border-spacing-2 border-slate-400'>
                    <tbody>
                        {fields?.map((o, i) => {
                            return (

                                <tr key={i} className="relative">

                                    {getOBJKeys(v?.data?.fields)?.map((f, j) => {
                                        return <td key={j} >
                                   
                                            {f !== 'category' ?<AInput  v={{register:v?.register, errors:v?.errors, control:v?.control,
                                                 data: { label:v.data?.head[j], name: `items.${i}.${f}`, isDisabled:f==='quantity', type:'text', required:true}}}/>
                                               
                                                : <ASelect v={{errors:v?.errors, control:v?.control,
                                                 data: { label: v.data?.head[j], name: `items.${i}.${f}`, type: 'select',  options:[o.category], isDisabled:true }}} />
                                            }
                                        </td>
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </fieldset>
    )
}

